<template>
  <PreviewFrame :accent="accent" :style="loopVars">
    <template #presenter>
      <ManifestBlock :block="manifest.presenter" />
    </template>
    <template v-if="manifest.audience" #audience>
      <ManifestBlock :block="manifest.audience" />
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlidePreviewManifest } from '../../lib/manifestTypes'
import PreviewFrame from './PreviewFrame.vue'
import ManifestBlock from './manifest/ManifestBlock.vue'

export default Vue.extend({
  name: 'ManifestPreview',
  components: { PreviewFrame, ManifestBlock },
  props: {
    manifest: { type: Object as PropType<SlidePreviewManifest>, required: true },
    /** Falls back to the slide-type's accent if the manifest doesn't set one. */
    fallbackAccent: { type: String, default: '#6A1EBB' },
  },
  computed: {
    accent(): string {
      return this.manifest.accent || this.fallbackAccent
    },
    loopVars(): Record<string, string> {
      // Surface loop timing as CSS vars so primitives can sync without
      // any JS animation work. Defaults are safe even when no loop
      // is declared (animations gate on duration > 0s).
      const { loop } = this.manifest
      return {
        '--loop-duration': loop?.duration || '0s',
        '--loop-tap-at': loop?.tapAt || '5%',
        '--loop-respond-at': loop?.respondAt || '20%',
      }
    },
  },
})
</script>
